import styled from 'styled-components';

import { Column } from '../../shared/styles';

const NameColumn = styled(Column)`
  width: 20%;
`;

const CompanyColumn = styled(Column)`
  width: 20%;
`;

const PartnershipTypeColumn = styled(Column)`
  width: 10%;
`;

const StatusColumn = styled(Column)`
  width: 10%;
`;

const ActionColumn = styled(Column)`
  width: 40%;
`;

export {
  ActionColumn,
  CompanyColumn,
  StatusColumn,
  NameColumn,
  PartnershipTypeColumn,
};
